import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import GroheCategoriesMenu from "./groheCategoriesMenu";

const GroheSubCategories = (props) => {

  const {isMobile, subCategoryOpened} = props;

  return (
    <section className={"grohe-section grohe-section--categories" + (subCategoryOpened ? " grohe-section--opened" : "")}>
      {isMobile ? null : (
        <h2 className="grohe-section__title">
          <FormattedMessage id="grohe.categories.accessoriesTitle"/>
        </h2>
      )}
      {subCategoryOpened ? <GroheCategoriesMenu isAccessory={true}/> : null}
    </section>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {subCategoryOpened} = store.groheState;
  return {
    isMobile,
    subCategoryOpened,
  };
};

export default connect(mapStateToProps)(GroheSubCategories)
